// src/context/EscrowBannerContext.js
import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import escrowBanner from '../assets/escrow-banner.png';

const EscrowBannerContext = createContext(null);

export function EscrowBannerProvider({ children }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [naturalSize, setNaturalSize] = useState({ width: 0, height: 0 });
  const imgRef = useRef(null); // hold preloaded Image()

  // Preload on mount
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      imgRef.current = img;
      setNaturalSize({ width: img.naturalWidth || 0, height: img.naturalHeight || 0 });
      setIsLoaded(true);
    };
    img.onerror = () => setIsLoaded(false);
    img.src = escrowBanner;
  }, []);

  const value = useMemo(() => ({
    src: escrowBanner,
    isLoaded,
    naturalSize,                    // {width, height}
    ensurePreloaded: () => {
      if (imgRef.current) return Promise.resolve(true);
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          imgRef.current = img;
          setNaturalSize({ width: img.naturalWidth || 0, height: img.naturalHeight || 0 });
          setIsLoaded(true);
          resolve(true);
        };
        img.onerror = () => resolve(false);
        img.src = escrowBanner;
      });
    },
  }), [isLoaded, naturalSize]);

  return (
    <EscrowBannerContext.Provider value={value}>
      {children}
    </EscrowBannerContext.Provider>
  );
}

export function useEscrowBanner() {
  const ctx = useContext(EscrowBannerContext);
  if (!ctx) throw new Error('useEscrowBanner must be used within EscrowBannerProvider');
  return ctx;
}
